import { ToothViewData } from '../Tooth/teethData';
import { Tooth, ToothRestorationType } from '../../../../graphql/graphql';
import React from 'react';
import DENTToothRestorationSurface from './DENTToothRestorationSurface';
import DENTToothRestorationFillingSurfaces from './DENTToothRestorationFillingSurfaces';

interface Props {
	toothViewData: ToothViewData;
	tooth: Tooth;
}

const DENTToothRestorationSurfaces = ({ toothViewData, tooth }: Props) => {
	const { restoration, pathology } = tooth;

	if (!restoration) {
		return <></>;
	}

	const isCrown = restoration.type === ToothRestorationType.Crown;

	return (
		<g opacity={isCrown ? '0.7' : '0.4'}>
			{restoration.surfaces?.map((surface, index) => (
				<DENTToothRestorationSurface
					key={index}
					surface={surface}
					toothViewData={toothViewData}
					restoration={restoration}
					pathology={pathology}
				/>
			))}
			<DENTToothRestorationFillingSurfaces
				toothViewData={toothViewData}
				pathology={pathology}
				fillings={restoration.fillings}
			/>
		</g>
	);
};

export default DENTToothRestorationSurfaces;
